import { render, staticRenderFns } from "./PanelCompetitionSettingRegulation.vue?vue&type=template&id=1fc3ec55&scoped=true&"
import script from "./PanelCompetitionSettingRegulation.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionSettingRegulation.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionSettingRegulation.vue?vue&type=style&index=0&id=1fc3ec55&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc3ec55",
  null
  
)

export default component.exports